import { useQuery } from "@tanstack/react-query";
import { EnvelopeSimple, Phone, MapPin, Clock, FacebookLogo, InstagramLogo, TennisBall } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";

export default function Contact() {
    const { data: s } = useQuery({ queryKey: ["settings"], queryFn: async () => (await api.get("/settings")).data });

    const items = [
        s?.address && { icon: MapPin, label: "Adresse", value: s.address },
        s?.phone && { icon: Phone, label: "Téléphone", value: s.phone, href: `tel:${s.phone.replace(/\s/g, "")}` },
        s?.email && { icon: EnvelopeSimple, label: "Email", value: s.email, href: `mailto:${s.email}` },
        s?.hours && { icon: Clock, label: "Horaires", value: s.hours },
    ].filter(Boolean);

    return (
        <div data-testid="contact-page">
            <PageHeader testid="contact-header" overline="Nous joindre" title="Contact" subtitle="Une question, une envie de jouer ? L'équipe du club vous répond." />
            <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 grid gap-6 lg:grid-cols-2">
                <div className="grid sm:grid-cols-2 gap-4">
                    {items.map((it, i) => (
                        <a
                            key={i}
                            href={it.href || undefined}
                            data-testid={`contact-${it.label}`}
                            className={`brand-card p-6 transition-colors duration-200 ${it.href ? "hover:border-clay" : ""}`}
                        >
                            <it.icon weight="duotone" size={28} className="text-clay" />
                            <div className="overline text-slate-400 mt-4 mb-1">{it.label}</div>
                            <div className="font-semibold text-navy">{it.value}</div>
                        </a>
                    ))}
                </div>

                <div className="brand-card bg-navy-deep text-white p-8 relative overflow-hidden">
                    <div className="absolute inset-0 court-lines opacity-30" />
                    <div className="relative">
                        <h2 className="font-display font-extrabold text-2xl tracking-tight">Réservez & suivez le club</h2>
                        <p className="mt-3 text-slate-300 text-sm leading-relaxed">
                            Réservez vos courts sur Ten'Up et retrouvez toute l'actu du club sur nos réseaux sociaux.
                        </p>
                        <a
                            href={s?.tenup_url || "https://tenup.fft.fr"}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="contact-tenup-btn"
                            className="mt-6 inline-flex items-center gap-2 rounded-full bg-clay px-6 py-3.5 font-bold transition-colors duration-200 hover:bg-clay-dark"
                        >
                            <TennisBall weight="fill" size={18} /> Ten'Up
                        </a>
                        <div className="mt-8 flex items-center gap-3">
                            {s?.facebook_url && (
                                <a href={s.facebook_url} target="_blank" rel="noopener noreferrer" data-testid="contact-facebook" aria-label="Facebook" className="grid place-items-center h-12 w-12 rounded-full bg-white/10 hover:bg-clay transition-colors">
                                    <FacebookLogo weight="fill" size={24} />
                                </a>
                            )}
                            {s?.instagram_url && (
                                <a href={s.instagram_url} target="_blank" rel="noopener noreferrer" data-testid="contact-instagram" aria-label="Instagram" className="grid place-items-center h-12 w-12 rounded-full bg-white/10 hover:bg-clay transition-colors">
                                    <InstagramLogo weight="fill" size={24} />
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
